"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var getLogger = function getLogger() {
  return window.logger || console;
};
var logger = {};
var loggerKey = ['info', 'trace', 'debug', 'warn', 'error'];
loggerKey.forEach(function (key) {
  logger[key] = function () {
    var _getLogger;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var cloneArgs = [].concat(args);
    // 加一个前缀
    cloneArgs[0] = "[xy-compsloader]".concat(cloneArgs[0]);
    (_getLogger = getLogger())[key].apply(_getLogger, (0, _toConsumableArray2["default"])(cloneArgs));
  };
});
var _default = exports["default"] = logger;